import React from 'react';
import { GraduationCap, Users } from 'lucide-react';

export const ForWho = () => {
  const personas = [
    {
      icon: GraduationCap,
      title: 'Para Docentes',
      description: 'Toma asistencia de tus aulas diariamente y genera reportes individuales. Controla 1 aula con el plan gratuito.',
      benefits: [
        'Interface simple y rápida',
        'Invitaciones por link',
        'Reportes por estudiante',
        'Exportación de datos',
        'Sin límite de estudiantes'
      ],
      highlight: 'Ideal para maestros individuales'
    },
    {
      icon: Users,
      title: 'Para Coordinadores Académicos',
      description: 'Supervisa la asistencia de múltiples docentes y aulas. Accede a analítica institucional y reportes consolidados. Ideal cuando ya hay varios docentes usando TuAsistencia en el colegio.',
      benefits: [
        'Vista multi-docente',
        'Reportes institucionales',
        'Analítica avanzada',
        'Gestión de permisos',
        'Dashboard consolidado'
      ],
      highlight: 'Perfecto para instituciones educativas'
    }
  ];

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            ¿Para quién es <span className="text-blue-600">TuAsistencia</span>?
          </h2>
          <p className="text-lg text-gray-600">
            Soluciones adaptadas a tu rol en la institución educativa
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {personas.map((persona, index) => {
            const Icon = persona.icon;
            return (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-3xl p-8 lg:p-10 hover:border-blue-300 transition-all duration-300 hover:shadow-lg"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="bg-blue-100 w-16 h-16 rounded-2xl flex items-center justify-center">
                    <Icon size={32} className="text-blue-600" strokeWidth={2} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      {persona.title}
                    </h3>
                    <p className="text-sm text-blue-600 font-medium mt-1">
                      {persona.highlight}
                    </p>
                  </div>
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed">
                  {persona.description}
                </p>

                <div className="space-y-3">
                  {persona.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <div className="mt-1 w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                        <div className="w-2 h-2 rounded-full bg-blue-600"></div>
                      </div>
                      <span className="text-gray-700">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
